export default __webpack_public_path__ + "static/media/latest-news-header-img-02.c9a06a81.jpg";